// assets/recently-viewed.js

const RECENTLY_VIEWED_KEY = 'recently_viewed_products';
const RECENTLY_VIEWED_MAX = 15;

let rvCurrentProduct = null; // 弹窗当前商品
let cartDrawerObserverInitialized = false;
// ⭐ 用来避免异步重复渲染的版本号
let rvRenderVersion = 0;

// 保存当前商品到 localStorage
function saveCurrentProductToRecentlyViewed() {
  const handle =
    (window.meta && window.meta.product && window.meta.product.handle) ||
    (document.querySelector('[data-product-handle]') &&
      document.querySelector('[data-product-handle]').dataset.productHandle);

  if (!handle) return;

  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
  } catch (e) {
    items = [];
  }

  // 去掉旧的同 handle
  items = items.filter((h) => h !== handle);

  // 新浏览的放最前面
  items.unshift(handle);

  // 限制数量
  items = items.slice(0, RECENTLY_VIEWED_MAX);

  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
}

// 渲染最近浏览到侧边购物车
function renderRecentlyViewedInDrawer() {
  const wrapper = document.querySelector('#recently-viewed-drawer');
  if (!wrapper) return;

  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
  } catch (e) {
    items = [];
  }
 let cartHandles = [];
  const handlesData = wrapper.getAttribute('data-cart-handles');
  if (handlesData) {
    try {
      cartHandles = JSON.parse(handlesData) || [];
    } catch (e) {
      cartHandles = [];
    }
  }
  const listEl = wrapper.querySelector('.recently-viewed__list');
  if (!listEl) return;

  // ⭐ 每次渲染前清空列表
  listEl.innerHTML = '';

  // ⭐ 本地数据再做一次去重
  const seen = new Set();
  items = items.filter((handle) => {
    if (seen.has(handle)) return false;
    seen.add(handle);
    return true;
  });

  if (!items.length) {
    wrapper.classList.add('recently-viewed--empty');
    return;
  } else {
    wrapper.classList.remove('recently-viewed--empty');
  }

  // ⭐ 当前这一次渲染的“版本号”
  const thisRender = ++rvRenderVersion;

  items.forEach((handle) => {
    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        // 如果有更晚的一次渲染已经开始，这次的结果就丢弃，防止重复 append
        if (thisRender !== rvRenderVersion) return;

        const item = document.createElement('div');
        item.className = 'recently-viewed__item';

        const image = product.images && product.images[0] ? product.images[0] : null;
        const url = product.url || `/products/${handle}`;
        const title = product.title;
 const inCart = cartHandles.includes(handle);

        // money 格式
        let moneyFormat =
          (window.recentlyMoneyFormat && typeof window.recentlyMoneyFormat === 'string')
            ? window.recentlyMoneyFormat
            : (window.Shopify && Shopify.money_format) || '{{amount}} €';

        let priceText = '';
        try {
          if (window.Shopify && Shopify.formatMoney) {
            priceText = Shopify.formatMoney(product.price, moneyFormat);
          } else {
            const symbol =
              (window.Shopify &&
                Shopify.currency &&
                Shopify.currency.symbol) ||
              '€';
            priceText = symbol + (product.price / 100).toFixed(2);
          }
        } catch (e) {
          const symbol =
            (window.Shopify &&
              Shopify.currency &&
              Shopify.currency.symbol) ||
            '€';
          priceText = symbol + (product.price / 100).toFixed(2);
        }

        item.innerHTML = `
          <a href="${url}" class="recently-viewed__image-wrapper">
            ${
              image
                ? `<img src="${image}&width=100&height=100&crop=center" alt="${title}" loading="lazy" class="recently-viewed__image" width="100" height="100" />`
                : ''
            }
             ${
              inCart
                ? '<svg t="1765267280825" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5352" width="200" height="200"><path d="M341.333333 853.333333a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z m448 0a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334zM161.024 170.666667a85.333333 85.333333 0 0 1 84.437333 72.832l8.149334 55.125333L853.333333 298.666667a106.666667 106.666667 0 0 1 102.954667 134.570666l-68.096 251.392A170.666667 170.666667 0 0 1 723.498667 810.666667H403.2a170.666667 170.666667 0 0 1-168.832-145.664L176.042667 271.061333a42.666667 42.666667 0 0 0-42.197334-36.394666H42.666667V170.666667h118.357333z m569.941333 256l-196.096 196.096-105.6-105.6L384 562.432l150.869333 150.869333 241.322667-241.365333L730.965333 426.666667z" fill="#e96916" p-id="5353"></path></svg>'
                : ''
            }
          </a>
          <div class="recently-viewed__info">
            <a href="${url}" class="recently-viewed__title">${title}</a>
            <div class="recently-viewed__price">${priceText}</div>
            <button
              type="button"
              class="recently-viewed__button js-recently-viewed-quick-add"
              data-product-handle="${handle}"
            >
              ${document.querySelector('#rv-add-to-cart-text')?.textContent?.trim() || '+ Přidat do košíku'}
            </button>
          </div>
        `;

        listEl.appendChild(item);
      })
      .catch(() => {});
  });
}

// 监听整页 DOM，只要 CartDrawer / recently-viewed 区域被重新插入，就重绘一次
function setupCartDrawerObserver() {
  if (cartDrawerObserverInitialized || !window.MutationObserver) return;

  const target = document.body;
  if (!target) return;

  const observer = new MutationObserver((mutations) => {
    let needRender = false;

    for (const m of mutations) {
      if (m.type !== 'childList') continue;

      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (
          node.id === 'CartDrawer' ||
          node.id === 'recently-viewed-drawer' ||
          (node.querySelector &&
            (node.querySelector('#CartDrawer') ||
              node.querySelector('#recently-viewed-drawer')))
        ) {
          needRender = true;
          break;
        }
      }

      if (needRender) break;
    }

    if (needRender) {
      renderRecentlyViewedInDrawer();
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });

  cartDrawerObserverInitialized = true;
}

// 刷新 Cart Drawer（Dawn 15.4）
async function refreshCartDrawer() {
  const cartDrawerWrapper = document.querySelector('#CartDrawer');
  if (!cartDrawerWrapper) return;

  try {
    const res = await fetch('/cart?section_id=cart-drawer');
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('#CartDrawer');

    if (newDrawer) {
      cartDrawerWrapper.innerHTML = newDrawer.innerHTML;
    }

    const drawerElement = document.querySelector('cart-drawer');
    if (drawerElement && typeof drawerElement.open === 'function') {
      drawerElement.open();
    } else {
      document.documentElement.classList.add('overflow-hidden');
      document.documentElement.classList.add('cart-drawer-open');
    }

    // 刷新完重新渲染最近浏览
    renderRecentlyViewedInDrawer();
  } catch (e) {
    console.error(e);
  }
}

// 加入购物车（用于一键加购 & 弹窗）
async function quickAddFromRecentlyViewed(variantId, buttonEl) {
  if (!variantId) return;

 try {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _recently_viewed_clicked: 'yes'
        }
      })
    });
  } catch(e) {}
  const body = new FormData();
  body.append('id', variantId);
  body.append('quantity', 1);
 // body.append('properties[_rv_source]', 'recently_viewed');
  try {
    if (buttonEl) {
      buttonEl.classList.add('is-loading');
      buttonEl.disabled = true;
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!res.ok) {
      throw new Error('Add to cart failed');
    }

    await refreshCartDrawer();
  } catch (e) {
    console.error(e);
  } finally {
    if (buttonEl) {
      buttonEl.classList.remove('is-loading');
      buttonEl.disabled = false;
    }
  }
}

// 依据选中的按钮，计算当前变体 & 更新价格 + 按钮 variantId
function updateModalVariantFromSelections() {
  const modal = document.getElementById('recently-viewed-modal');
  if (!modal || !rvCurrentProduct) return;

  const groups = modal.querySelectorAll('.rv-modal__option-group');
  const selectedValues = Array.from(groups).map((group) => {
    const active = group.querySelector('.rv-option-button.is-active');
    return active ? active.dataset.optionValue : null;
  });

  let variant =
    rvCurrentProduct.variants.find((v) => {
      const vOptions = [v.option1, v.option2, v.option3].filter(Boolean);
      return selectedValues.every((val, index) => !val || vOptions[index] === val);
    }) || rvCurrentProduct.variants[0];

  const submitBtn = modal.querySelector('.rv-modal__submit');
  const priceEl = modal.querySelector('.rv-modal__price');

  if (submitBtn && variant) {
    submitBtn.dataset.variantId = variant.id;
  }

  // 用店铺 money_format（带货币符号）
  if (priceEl && variant) {
    let priceText = '';

    try {
      let moneyFormat =
        (window.recentlyMoneyFormat && typeof window.recentlyMoneyFormat === 'string')
          ? window.recentlyMoneyFormat
          : (window.Shopify && Shopify.money_format) || '{{amount}} €';

      if (window.Shopify && Shopify.formatMoney) {
        priceText = Shopify.formatMoney(variant.price, moneyFormat);
      } else {
        const symbol =
          (window.Shopify &&
            Shopify.currency &&
            Shopify.currency.symbol) ||
          '€';
        priceText = symbol + (variant.price / 100).toFixed(2);
      }
    } catch (e) {
      const symbol =
        (window.Shopify &&
          Shopify.currency &&
          Shopify.currency.symbol) ||
        '€';
      priceText = symbol + (variant.price / 100).toFixed(2);
    }

    priceEl.textContent = priceText;
  }
}

// 打开弹窗（按钮式属性）
function openRecentlyViewedModal(product) {
  rvCurrentProduct = product;

  const modal = document.getElementById('recently-viewed-modal');
  if (!modal) return;

  const imageEl = modal.querySelector('.rv-modal__image');
  const titleEl = modal.querySelector('.rv-modal__title');
  const optionsWrapper = modal.querySelector('.rv-modal__options');
  const submitBtn = modal.querySelector('.rv-modal__submit');

  const variants = product.variants || [];
  const firstAvailableVariant =
    variants.find((v) => v.available) || variants[0];

  // 图片
  if (imageEl) {
    const image = product.images && product.images[0] ? product.images[0] : null;
    if (image) {
      imageEl.src = image;
      imageEl.alt = product.title;
    } else {
      imageEl.src = '';
      imageEl.alt = '';
    }
  }

  // 标题
  if (titleEl) {
    titleEl.textContent = product.title;
  }

  // 清空 options
  if (optionsWrapper) {
    optionsWrapper.innerHTML = '';

    const options = product.options || [];

    options.forEach((opt, index) => {
      const optionIndex = index + 1;
      const name = opt.name || `Option ${optionIndex}`;

      const values =
        (opt.values && opt.values.length
          ? opt.values
          : Array.from(
              new Set(
                variants
                  .map((v) => v[`option${optionIndex}`])
                  .filter((val) => val != null)
              )
            )) || [];

      if (!values.length) return;

      const group = document.createElement('div');
      group.className = 'rv-modal__option-group';
      group.dataset.optionGroup = String(optionIndex);

      const label = document.createElement('div');
      label.className = 'rv-modal__option-label';
      label.textContent = name;

      const buttonsWrapper = document.createElement('div');
      buttonsWrapper.className = 'rv-modal__option-buttons';

      values.forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rv-option-button';
        btn.textContent = val;
        btn.dataset.optionIndex = String(optionIndex);
        btn.dataset.optionValue = val;

        // 默认选中当前可售变体对应的值
        if (
          firstAvailableVariant &&
          firstAvailableVariant[`option${optionIndex}`] === val
        ) {
          btn.classList.add('is-active');
        }

        buttonsWrapper.appendChild(btn);
      });

      group.appendChild(label);
      group.appendChild(buttonsWrapper);
      optionsWrapper.appendChild(group);
    });
  }

  // 先根据默认选中状态更新一次变体 & 价格
  updateModalVariantFromSelections();

  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.classList.remove('is-loading');
  }

  modal.hidden = false;
}

function closeRecentlyViewedModal() {
  const modal = document.getElementById('recently-viewed-modal');
  if (!modal) return;
  modal.hidden = true;
  rvCurrentProduct = null;
}

// Drawer 打开时：渲染最近浏览 + 设置观察器
function bindCartDrawerRecentlyViewed() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('transitionend', () => {
      if (cartDrawer.hasAttribute('open') || cartDrawer.dataset.open === 'true') {
        renderRecentlyViewedInDrawer();
      }
    });
  }

  setupCartDrawerObserver();
  renderRecentlyViewedInDrawer();
}

// 统一 click 事件代理
document.addEventListener('click', (event) => {
  // 1) 属性按钮切换
  const optionBtn = event.target.closest('.rv-option-button');
  if (optionBtn) {
    event.preventDefault();
    const group = optionBtn.closest('.rv-modal__option-group');
    if (group) {
      group.querySelectorAll('.rv-option-button').forEach((btn) => {
        btn.classList.toggle('is-active', btn === optionBtn);
      });
      updateModalVariantFromSelections();
    }
    return;
  }

  // 2) 最近浏览条目里的 “快速加购 / 打开弹窗” 按钮
  const quickBtn = event.target.closest('.js-recently-viewed-quick-add');
  if (quickBtn) {
    event.preventDefault();
    const handle = quickBtn.dataset.productHandle;
    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        const hasCustomTag =
        Array.isArray(product.tags) &&
        product.tags.some((tag) => tag && tag.toLowerCase() === 'custom');

      if (hasCustomTag) {
        const url = product.url || `/products/${handle}`;
        window.location.href = url;
        return;
      }
        if (!product.variants || product.variants.length <= 1) {
          const onlyVariant = product.variants[0];
          if (onlyVariant) {
            quickAddFromRecentlyViewed(onlyVariant.id, quickBtn);
          }
          return;
        }

        // 多变体 → 打开弹窗
        openRecentlyViewedModal(product);
      })
      .catch((e) => console.error(e));

    return;
  }

  // 3) 关闭弹窗：X 或 背景
  const closeBtn = event.target.closest('.rv-modal__close');
  const overlay = event.target.closest('.rv-modal__overlay');
  if (closeBtn || overlay) {
    closeRecentlyViewedModal();
    return;
  }

  // 4) 弹窗里的「加入购物车」按钮
  const submitBtn = event.target.closest('.rv-modal__submit');
  if (submitBtn) {
    event.preventDefault();
    const variantId = submitBtn.dataset.variantId;
    if (!variantId) return;
    quickAddFromRecentlyViewed(variantId, submitBtn);
    closeRecentlyViewedModal();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  saveCurrentProductToRecentlyViewed();
  bindCartDrawerRecentlyViewed();
});
